define('models/search/search_suggestion',["backbone"], function (Backbone) {

    var SearchSuggestion = Backbone.Model.extend({
        parse: function (data) {
            var response = {};
            // response.SuggestionType = data.ST;
            // response.SearchValue = data.SV;
            // response.Limit = data.L;

            response.Query = data.Q;
            response.SuggestionName = data.SGST;
            response.GUID = data.GUID;
            response.SuggestionDescription = data.FLD1;
            
            return response;
        },

        initialize: function (options) {
            options = options || {};

            this.Query = options.Q;
            this.SuggestionName = options.SGST;
            this.GUID = options.GUID;
            this.SuggestionDescription = options.FLD1;
            
        }
    });

    return SearchSuggestion;
});

